<template>
  <button class="rounded py-8 px-16 font-bold text-16">
    <slot />
  </button>
</template>
